import { render, staticRenderFns } from "./BatchExamineList.vue?vue&type=template&id=62224b2e&scoped=true&"
import script from "./BatchExamineList.vue?vue&type=script&lang=js&"
export * from "./BatchExamineList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62224b2e",
  null
  
)

export default component.exports